import Grid from "@mui/material/Grid";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { addDays } from "date-fns";

export function DateRange(
  props: {
    from: Date | null,
    to: Date | null,
    setFrom: (value: Date | null) => void,
    setTo: (value: Date | null) => void,
    required?: boolean | { from?: boolean, to?: boolean },
  }
) {
  return <>
    <Grid item xs={4} md={2} sx={{ textAlign: 'right' }}>From:</Grid>
    <Grid item xs={8} md={4}>
      <DatePicker
        value={props.from}
        onChange={date => {
          if (!date && (props.required === true || (props.required && props.required.from))) return;
          props.setFrom(date)
        }}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
        showDaysOutsideCurrentMonth
        disableFuture
      />
    </Grid>
    <Grid item xs={4} md={2} sx={{ textAlign: 'right' }}>To:</Grid>
    <Grid item xs={8} md={4}>
      <DatePicker
        value={props.to}
        onChange={date => {
          if (!date && (props.required === true || (props.required && props.required.to))) return;
          props.setTo(date)
        }}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
        showDaysOutsideCurrentMonth
        disableFuture
      />
    </Grid>
  </>
}

export function DateTimeRange(
  props: {
    from: DateTime | null,
    to: DateTime | null,
    setFrom: (value: DateTime | null) => void,
    setTo: (value: DateTime | null) => void,
  }) {

  return (<>
    <Grid item xs={4} md={2} lg={1} sx={{ textAlign: 'right' }}>From:</Grid>
    <Grid item xs={8} md={6} lg={3}>
      <DatePicker
        value={props.from?.date || null}
        onChange={date => props.setFrom(date ? new DateTime(date, props.from?.time ?? null) : null)}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
        showDaysOutsideCurrentMonth
        disableFuture
      />
    </Grid>
    <Grid item xs={4} sx={{ display: { md: 'none' } }} />
    <Grid item xs={8} md={4} lg={2}>
      <TimePicker
        value={props.from?.time || null}
        onChange={time => {
          time?.setSeconds(0, 0);
          return props.setFrom(props.from ? new DateTime(props.from.date, time) : null)
        }}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
      />
    </Grid>
    <Grid item xs={4} md={2} lg={1} sx={{ textAlign: 'right' }}>To:</Grid>
    <Grid item xs={8} md={6} lg={3}>
      <DatePicker
        value={props.to?.date || null}
        onChange={date => props.setTo(date ? new DateTime(date, props.to?.time ?? null, true) : null)}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
        showDaysOutsideCurrentMonth
        disableFuture
      />
    </Grid>
    <Grid item xs={4} sx={{ display: { md: 'none' } }} />
    <Grid item xs={8} md={4} lg={2}>
      <TimePicker
        value={props.to?.time || null}
        onChange={time => {
          time?.setSeconds(0, 0);
          return props.setTo(props.to ? new DateTime(props.to.date, time, true) : null);
        }}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
      />
    </Grid>
  </>)
}

export class DateTime {
  date: Date;
  time: Date | null;
  end: boolean;

  constructor(date: Date, time: Date | null, end: boolean = false) {
    this.date = date;
    this.time = time;
    this.end = end;
  }

  dateTime(): Date {
    return this.time
      ? new Date(
        this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
        this.time.getHours(), this.time.getMinutes(), this.time.getSeconds(), this.time.getMilliseconds()
      )
      : this.end
        ? addDays(new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate()), 1)
        : new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());
  }
}
